export default __webpack_public_path__ + "static/preschool2-9379a0dd60a1e120c01829fffd554ad3.jpg";